import { useQuery, useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getChainsApi, getChainsPaginatedApi, getChainApi, updateChainApi } from "../api/chainsApi";
import type { RestUpdateChain } from "@KassaroAB/shared/types/chain";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const useGetChainsQuery = () => {
  return useQuery({
    queryKey: ["chains"],
    queryFn: () => getChainsApi(),
  });
};

export const useGetChainsInfiniteQuery = () => {
  return useInfiniteQuery({
    queryKey: ["chains", "admin"],
    queryFn: ({ pageParam }: { pageParam: string | null }) => getChainsPaginatedApi(pageParam, 20),
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      if (lastPage.length < 20) return undefined;
      return lastPage.length > 0 ? lastPage[lastPage.length - 1].id : undefined;
    },
  });
};

export const useGetChainQuery = (chainId: ChainId | undefined) => {
  return useQuery({
    queryKey: ["chains", chainId],
    queryFn: () => getChainApi(chainId!),
    enabled: !!chainId,
  });
};

export const useUpdateChainMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ chainId, chain }: { chainId: ChainId; chain: RestUpdateChain }) =>
      updateChainApi(chainId, chain),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["chains"] });
    },
  });
};
